import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=23df6d5e&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=js&"
export * from "./Conference.vue?vue&type=script&lang=js&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=23df6d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df6d5e",
  null
  
)

export default component.exports